import { ExternalLink } from "../Link";

export function InstaAccountLink({
  account,
}: {
  account: { username?: string; name?: string; id?: string };
}) {
  if (!account.username) {
    return <>{account.name || account.id}</>;
  }
  return (
    <ExternalLink href={`https://www.instagram.com/${account.username}`}>
      @{account.username}
    </ExternalLink>
  );
}
